import { InjectionToken } from '@angular/core';
import { IdToken } from '../interfaces/id-token.interface';

export const IDENTITY = new InjectionToken<IdToken | null>('IdToken');
